<template>
    <div>
        <div class="gs:grid">
            <div class="lg:col-8 pt-8">
                <input
                    id="pac-input"
                    type="text"
                    class="form-input form-input--big mb-4"
                    placeholder="Enter a location"
                />
                <div id="map" class="wrapper__map w-full mb-3"></div>
                <div class="tx-14 tx-grey opacity-70 mb-4" id="current">
                    Para cambiar la ubicación del vehículo, arrastra el marcador a la
                    zona deseada.
                </div>
            </div>
            <div class="lg:col-8">
                <div class="form-grid" v-show="err || editable">
                    <div class="form-group sm:col-8">
                        <label class="form-label form-label--big" for="">Estado</label>
                        <v-select
                            placeholder="Selecciona un Estado"
                            class="form-input form-input--big form-input--v-select"
                            label="title"
                            :class="[err && err['state_id'] ? 'border-red' : '', state_id != '' ? 'input-filled' : '']"
                            :reduce="(state) => state.id"
                            :options="states"
                            v-model="state_id"
                        >
                            <span slot="no-options">Sin resultados</span>
                        </v-select>
                    </div>
                    <div class="form-group sm:col-8">
                        <label class="form-label form-label--big" for="">Ciudad</label>
                        <v-select
                            placeholder="Selecciona una ciudad"
                            class="form-input form-input--big form-input--v-select"
                            label="title"
                            :class="[err && err['city_id'] ? 'border-red' : '', city_id != '' ? 'input-filled' : '']"
                            :reduce="(city) => city.id"
                            :options="cities"
                            v-model="city_id"
                            >
                            <span slot="no-options">Sin resultados</span>
                        </v-select>
                    </div>
                </div>
                <div class="form-grid" v-show="err || editable">
                    <div class="form-group sm:col-8">
                        <label class="form-label form-label--big" for="">Colonia</label>
                        <v-select
                            placeholder="Selecciona una ciudad"
                            class="form-input form-input--big form-input--v-select"
                            label="title"
                            :class="[err && err['suburb_id'] ? 'border-red' : '', suburb_id != '' ? 'input-filled' : '']"
                            :reduce="(suburb) => suburb.id"
                            :options="suburbs"
                            v-model="suburb_id"
                            >
                            <span slot="no-options">Sin resultados</span>
                        </v-select>
                    </div>
                    <div class="form-group sm:col-8">
                        <label class="form-label form-label--big">Código Postal</label >
                        <the-mask
                            :class="err && err['zip_code'] ? 'border-red' : ''"
                            class="form-input form-input--big"
                            type="tel"
                            v-model="zip_code"
                            placeholder="#####"
                            :masked="false"
                            mask="#####"
                        ></the-mask>
                    </div>
                </div>
                <div class="form-grid" v-show="err || editable">
                    <div class="form-group col-16">
                        <label class="form-label form-label--big" for="">
                            Calle y número
                        </label>
                        <input required :class="err && err['address'] ? 'border-red' : ''" class="form-input form-input--big" type="text" v-model="address">
                    </div>
                </div>
                <div class="form-grid">
                    <div class="form-group col-7 sm:col-4 xl:col-5">
                        <!-- LADA -->
                        <label class="form-label form-label--big" for=""> Lada </label>
                        <v-select
                            :options="ladas"
                            v-model="lada_phone"
                            class="form-input--v-select form-input form-input--big input-filled"
                            name="lada_phone"
                            id="lada_phone"
                        ></v-select>
                    </div>
                    <!-- PHONE -->
                    <div class="form-group col-9 sm:col-12 xl:col-11">
                        <label class="form-label form-label--big" for="">
                            Teléfono
                        </label>
                        <the-mask
                            :class="err && err['phone'] ? 'border-red' : ''"
                            class="form-input form-input--big"
                            type="tel"
                            v-model="phone"
                            placeholder="##-##-##-##-##"
                            :masked="false"
                            mask="##-##-##-##-##"
                        ></the-mask>
                    </div>
                </div>
                <div class="form-grid">
                    <div class="form-group col-7 sm:col-4 xl:col-5">
                        <!-- LADA -->
                        <label class="form-label form-label--big" for=""> Lada </label>
                        <v-select
                            :options="ladas"
                            v-model="lada_cellphone"
                            class="form-input--v-select form-input form-input--big input-filled"
                            name="lada_cellphone"
                            id="lada_cellphone"
                        ></v-select>
                    </div>
                    <!-- WHATSAPP -->
                    <div class="form-group col-9 sm:col-12 xl:col-11">
                        <label class="form-label form-label--big" for="">
                            Celular
                        </label>
                        <the-mask
                            class="form-input form-input--big"
                            type="tel"
                            v-model="cellphone"
                            placeholder="##-##-##-##-##"
                            :masked="false"
                            mask="##-##-##-##-##"
                        ></the-mask>
                    </div>
                </div>
            </div>
        </div>

        <!-- BTN NEXT -->
        <div
            v-show="step == 5"
            @click="$emit('next')"
            class="btn btn--green-ad btn--next weight-500 flex mx-a sm:mr-0 mt-8"
        >
            Continuar
        </div>
    </div>
</template>

<script>
    import { Loader, LoaderOptions } from "google-maps";

    export default {
        props: ["api", "countries", "err", "step", "editable", "states"],

        data: () => ({
            address: "",
            autocomplete: null,
            cellphone: "",
            cities: [],
            city_id: null,
            currentAddress: "",
            currentCoordenades: {
                lat: 0,
                lng: 0,
            },
            currentZoom: 11,
            geocoder: null,
            google: null,
            lada_cellphone: "",
            lada_phone: "",
            loader: null,
            location : {},
            map: null,
            mapTitle: "",
            marker: null,
            phone: "",
            populatingCurrent : false,
            state_id: null,
            suburbs: [],
            suburb_id: null,
            updatingLocation : false,
            user_type: null,
            zip_code: "",
        }),
        watch: {
            //TODO: you can send all the values on one event.
            address(newValue) {
                this.$emit("addressChanged", newValue);
            },
            cellphone(newValue) {
                this.$emit("cellphoneChanged", newValue);
            },
            city_id(newValue) {
                this.getSuburbs(this.state_id, newValue);
                this.$emit("cityChanged", newValue);
            },
            lada_cellphone(newValue) {
                this.$emit("ladaCellphoneChanged", newValue);
            },
            lada_phone(newValue) {
                this.$emit("ladaPhoneChanged", newValue);
            },
            location : {
                deep: true,
                handler(newValue) {
                    this.updatingLocation = true;
                    this.zip_code = newValue.postal_code;
                    if(newValue.street_number !== "" && newValue.route !== "") {
                        this.address = `${newValue.route} ${newValue.street_number}`
                    } else {
                        this.address = "";
                    }
                    if(newValue.administrative_area_level_1 === "") {
                        this.updatingLocation = false;
                        return this.state_id = null;
                    }
                    const stateExistsInSystem = this.states.find(state => state.name === newValue.administrative_area_level_1);
                    if(!stateExistsInSystem) {
                        return this.state_id = null;
                    }
                    if(this.state_id != stateExistsInSystem.id) {
                     return this.state_id = stateExistsInSystem.id;
                    }

                     if(this.location.locality === "") {
                        this.updatingLocation = false;
                         return this.city_id = null;
                    }

                    const cityExist = this.cities.find(city => city.title === this.location.locality);
                    if(!cityExist) {
                    this.updatingLocation = false;
                        return this.city_id = null;
                    }
                    if(this.city_id !== cityExist.id) {
                        return this.city_id = cityExist.id;
                    }

                    this.updatingLocation = false;
                    if(this.location.sublocality_level_1 === "") {
                        return this.suburb_id = null;
                    }
                    const suburbExist = this.suburbs.find(suburb => suburb.title === this.location.sublocality_level_1);
                    if(!suburbExist) {
                        return this.suburb_id = null;
                    }
                    return this.suburb_id = suburbExist.id;
                }
            },
            phone(newValue) {
                this.$emit("PhoneChanged", newValue);
            },
            state_id(newValue) {
                this.getCities(newValue);
                this.$emit("stateChanged", newValue);
            },
            suburb_id(newValue) {
                this.$emit("suburbChanged", newValue);
            },
            zip_code(newValue) {
                this.$emit("zipcodeChanged",newValue);
            },
            
            editable(newValue) {
                if(this.editable !== undefined && !!this.editable) {
                    this.populatingCurrent = true;
                    this.cellphone = this.editable.cellphone;
                    this.lada_phone = this.editable.phone_country_code ? this.editable.phone_country_code : this.editable.lada_phone;
                    this.lada_cellphone = this.editable.cellphone_country_code ? this.editable.cellphone_country_code : this.editable.lada_cellphone;
                    this.phone = this.editable.phone;
                    this.zip_code = this.editable.zip_code;
                    this.address = this.editable.address;
                    this.state_id = parseInt(this.editable.state_id);
                }
            },
        },
        components: {
            Loader,
            LoaderOptions,
        },
        mounted() {
            if (this.editable) {
                this.populatingCurrent = true;
                this.cellphone = this.editable.cellphone;
                this.lada_phone = this.editable.phone_country_code ? this.editable.phone_country_code : this.editable.lada_phone;
                this.lada_cellphone = this.editable.cellphone_country_code ? this.editable.cellphone_country_code : this.editable.lada_cellphone;
                this.phone = this.editable.phone;
                this.zip_code = this.editable.zip_code;
                this.address = this.editable.address;
                this.state_id = this.editable.state_id;
            } else {
                this.updateMaps();
                this.lada_phone = "+52";
                this.lada_cellphone = "+52";
            }
        },
        computed: {
            ladas() {
                var data = [];

                $.each(this.countries, function (key, country) {
                    if ($.inArray(country.phone_code, data) === -1)
                        data.push(country.phone_code);
                });
                return data.sort();
            },
        },
        methods: {
            setAddress(address) {
                this.currentAddress = address;
            },
            async getCities(stateId) {
                try {
                    const {data} = await axios.get(`/client/states/${stateId}/cities`);
                    this.cities = data;
                } catch(error) {
                    this.cities = [];
                    this.city_id = null;
                    console.error(error);
                }
                if(this.populatingCurrent) {
                    return this.city_id = parseInt(this.editable.city_id);
                }

                if(this.updatingLocation) {
                    if(this.location.locality === "") {
                        this.updatingLocation = false;
                         return this.city_id = null;
                    }

                    const cityExist = this.cities.find(city => city.title === this.location.locality);
                    if(!cityExist) {
                    this.updatingLocation = false;
                        return this.city_id = null;
                    }
                    return this.city_id = cityExist.id;
                }
                return this.city_id =null;
            },
            async getSuburbs(stateId, cityId) {
                try {
                    const {data} = await axios.get(`/client/states/${stateId}/cities/${cityId}/suburbians`);
                    this.suburbs = data;
                } catch(error) {
                    this.suburbs = [];
                    this.suburb_id = null;
                    console.error(error);
                }
                if(this.populatingCurrent) {
                    this.updateMaps(this.editable.lat, this.editable.lng);
                    return this.suburb_id = parseInt(this.editable.suburb_id);
                }
                if(this.updatingLocation) {
                    this.updatingLocation = false;
                    if(this.location.sublocality_level_1 === "") {
                        return this.suburb_id = null;
                    }
                    const suburbExist = this.suburbs.find(suburb => suburb.title === this.location.sublocality_level_1);
                    if(!suburbExist) {
                    this.updatingLocation = false;
                        return this.suburb_id = null;
                    }
                    return this.suburb_id = suburbExist.id;
                }
                return suburb_id = null;
            },
            async updateMaps( latitude = "19.3910038", longitude = "-99.2836968") {
                let vm = this;
                vm.currentCoordenades.lat = parseFloat(latitude.trim());
                vm.currentCoordenades.lng = parseFloat(longitude.trim());

                const options = {
                    libraries: ["places"],
                };
                vm.loader = new Loader( "AIzaSyAIvqtv9l7H1jQBpVaZ9jMKiUFUJWnJyck", options);
                vm.google = await vm.loader.load();
                vm.geocoder = new google.maps.Geocoder();

                vm.map = new google.maps.Map(document.getElementById("map"), {
                    center: vm.currentCoordenades,
                    zoom: vm.currentZoom,
                    gestureHandling: "greedy",
                });
                vm.marker = new google.maps.Marker({
                    position: vm.currentCoordenades,
                    map: vm.map,
                    draggable: true,
                    animation: google.maps.Animation.DROP,
                    title: vm.mapTitle,
                });
                let geocode = {};
                if (vm.editable && vm.editable.place_id) {
                    geocode = { placeId: vm.editable.place_id };
                    vm.geocoder.geocode(geocode, vm.reverseLocation);
                } else if (vm.editable) {
                    geocode = { location: vm.currentCoordenades };
                    vm.geocoder.geocode(geocode, vm.reverseLocation);
                }
                const input = document.getElementById("pac-input");
                const autocompleteOptions = {
                    types: ["address"],
                    ComponentRestrictions: { country: "mx" },
                };
                vm.autocomplete = new google.maps.places.Autocomplete(
                    input,
                    autocompleteOptions
                );

                vm.autocomplete.addListener("place_changed", () => {
                    vm.marker.setVisible(false);
                    const place = vm.autocomplete.getPlace();

                    if (!place.geometry) {
                        // User entered the name of a Place that was not suggested and
                        // pressed the Enter key, or the Place Details request failed.
                        window.alert(
                            "No details available for input: '" +
                                place.name +
                                "'"
                        );
                        return;
                    }

                    // If the place has a geometry, then present it on a map.
                    if (place.geometry.viewport) {
                        vm.map.fitBounds(place.geometry.viewport);
                    } else {
                        vm.map.setCenter(place.geometry.location);
                        vm.map.setZoom(vm.currentZoom);
                    }
                    vm.marker.setPosition(place.geometry.location);
                    vm.$parent.lat = place.geometry.location.lat();
                    vm.$parent.lng = place.geometry.location.lng();
                    vm.marker.setVisible(true);
                    if (place.address_components) {
                        this.updateLocationInfo(
                            place.address_components,
                            place.place_id
                        );
                    }
                });

                google.maps.event.addListener(vm.marker, "dragend", function ( evt) {
                    vm.$parent.lat = evt.latLng.lat();
                    vm.$parent.lng = evt.latLng.lng();
                    vm.map.setCenter(evt.latLng);
                    vm.geocoder.geocode(
                        { location: evt.latLng },
                        vm.reverseLocation
                    );
                    document.getElementById("current").innerHTML =
                        "<p>La nueva ubicación ha sido configurada.</p>";
                });

                google.maps.event.addListener(vm.marker, "dragstart", function ( evt) {
                    document.getElementById("current").innerHTML =
                        "<p>Marcador en movimiento...</p>";
                });

                const centerControlDiv = document.createElement("div");
                vm.CenterControl(centerControlDiv, vm.map, vm.marker);
                centerControlDiv.index = 1;
                vm.map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);
            },
            reverseLocation(results, status) {
                if (status === "OK") {
                    if (results[0]) {
                        const input = document.getElementById("pac-input");
                        input.value = results[0].formatted_address;
                        if(this.populatingCurrent) {
                            return this.populatingCurrent = false;
                        }
                        this.updateLocationInfo(
                            results[0].address_components,
                            results[0].place_id
                        );
                    } else {
                        window.alert("No results found");
                    }
                } else {
                    window.alert("Geocoder failed due to: " + status);
                }
            },
            CenterControl(controlDiv, map, marker) {
                // Set CSS for the control border.
                const controlUI = document.createElement("div");
                controlUI.style.backgroundColor = "#fff";
                controlUI.style.border = "2px solid #fff";
                controlUI.style.borderRadius = "3px";
                controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
                controlUI.style.cursor = "pointer";
                controlUI.style.marginTop = "10px";
                controlUI.style.marginBottom = "22px";
                controlUI.style.textAlign = "center";
                controlUI.title = "Click to recenter the map";
                controlDiv.appendChild(controlUI);

                // Set CSS for the control interior.
                const controlText = document.createElement("div");
                controlText.style.color = "rgb(25,25,25)";
                controlText.style.fontFamily = "Roboto,Arial,sans-serif";
                controlText.style.fontSize = "14px";
                controlText.style.lineHeight = "36px";
                controlText.style.paddingLeft = "5px";
                controlText.style.paddingRight = "5px";
                controlText.innerHTML = "Centrar mapa";
                controlUI.appendChild(controlText);

                // Setup the click event listeners: simply set the map to Chicago.
                controlUI.addEventListener("click", () => {
                    let vm = this;
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(function (
                            position
                        ) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            map.setCenter(pos);
                            marker.setPosition(pos);
                            vm.$parent.lat = position.coords.latitude;
                            vm.$parent.lng = position.coords.longitude;
                            vm.geocoder.geocode(
                                { location: pos },
                                vm.reverseLocation
                            );
                        });
                    }
                });
            },
            particularMap() {
                const citymap = {
                    center: vm.currentCoordenades,
                    population: 14,
                };
                const cityCircle = new google.maps.Circle({
                    strokeColor: "#0047ba",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#0047ba",
                    fillOpacity: 0.35,
                    map: vm.map,
                    center: citymap.center,
                    radius: Math.sqrt(citymap.population) * 100,
                });
                map_image;
            },
            updateLocationInfo(placeDetails, placeId) {
                let vm = this;
                let componentsFilter = {
                    administrative_area_level_1 : "",
                    locality : "",
                    postal_code : "",
                    route : "",
                    street_number : "",
                    sublocality_level_1 : "",
                };
                placeDetails.forEach( place => {
                    place.types.forEach(type => {
                        if(componentsFilter.hasOwnProperty(type)) {
                            componentsFilter[type] = place.long_name;
                        }
                    });
                });
                this.location = componentsFilter;
                this.$emit("placeChanged", placeId);
            },

        },

    };
</script>
